<script setup>
// Right Chat - casca de modal do Kanban proprio.
// Escrita a mao (e nao reusando o Modal do upstream) para nao amarrar a tela a um
// componente que muda de assinatura entre versoes do Chatwoot.
import { onMounted, onBeforeUnmount } from 'vue';

defineProps({
  title: { type: String, required: true },
});

const emit = defineEmits(['close']);

const onKeydown = event => {
  if (event.key === 'Escape') emit('close');
};

onMounted(() => document.addEventListener('keydown', onKeydown));
onBeforeUnmount(() => document.removeEventListener('keydown', onKeydown));
</script>

<template>
  <Teleport to="body">
    <div class="rk-modal" role="dialog" aria-modal="true" @click.self="emit('close')">
      <div class="rk-modal__panel">
        <header class="rk-modal__head">
          <h2 class="rk-modal__title">{{ title }}</h2>
          <button
            type="button"
            class="rk-modal__close"
            aria-label="Fechar"
            @click="emit('close')"
          >
            ×
          </button>
        </header>

        <div class="rk-modal__body">
          <slot />
        </div>

        <footer class="rk-modal__foot">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.rk-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgb(15 23 42 / 45%);
}

.rk-modal__panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow: hidden;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgb(15 23 42 / 25%);
}

.rk-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #e2e8f0;
}

.rk-modal__title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.rk-modal__close {
  font-size: 20px;
  line-height: 1;
  color: #64748b;
  cursor: pointer;
  background: transparent;
  border: 0;
}

.rk-modal__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  overflow-y: auto;
}

.rk-modal__foot {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
}

.dark .rk-modal__panel {
  background: #1e293b;
}

.dark .rk-modal__head,
.dark .rk-modal__foot {
  border-color: #334155;
}

.dark .rk-modal__title {
  color: #e2e8f0;
}
</style>
